/** @format */

import React from 'react';
import { MenuItemWrapper } from '../../styles';
import { Trans } from 'react-i18next';
import Link from '../../../Link';
import { useModal } from '../../../../modules/ui';

const MenuItem = ({ i18nKey, path }) => {
	const { boundToggleRightSidebar } = useModal();

	return (
		<MenuItemWrapper>
			<Link path={path}>
				<Trans i18nKey={i18nKey} />
			</Link>
		</MenuItemWrapper>
	);
};

export default React.memo(MenuItem);
